import { render, staticRenderFns } from "./selectCourseCard.vue?vue&type=template&id=3c57fc60&scoped=true&"
import script from "./selectCourseCard.vue?vue&type=script&lang=js&"
export * from "./selectCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./selectCourseCard.vue?vue&type=style&index=0&id=3c57fc60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57fc60",
  null
  
)

export default component.exports